var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/cpu-charge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cpu-charge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.40008 13.3333H9.60008C12.2667 13.3333 13.3334 12.2666 13.3334 9.59996V6.39996C13.3334 3.73329 12.2667 2.66663 9.60008 2.66663H6.40008C3.73341 2.66663 2.66675 3.73329 2.66675 6.39996V9.59996C2.66675 12.2666 3.73341 13.3333 6.40008 13.3333Z",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.00008 11.3333H9.00008C10.6667 11.3333 11.3334 10.6666 11.3334 8.99996V6.99996C11.3334 5.33329 10.6667 4.66663 9.00008 4.66663H7.00008C5.33341 4.66663 4.66675 5.33329 4.66675 6.99996V8.99996C4.66675 10.6666 5.33341 11.3333 7.00008 11.3333Z",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.34009 2.66671V1.33337",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8 2.66671V1.33337",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.6667 2.66671V1.33337",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.3333 5.33337H14.6666",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.3333 8H14.6666",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.3333 10.6666H14.6666",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.6667 13.3334V14.6667",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.00659 13.3334V14.6667",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M5.34009 13.3334V14.6667",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M1.33325 5.33337H2.66659",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M1.33325 8H2.66659",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1.33325 10.6666H2.66659",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.9999 6.46667L7.37323 7.56001C7.23323 7.80001 7.34656 8.00001 7.62656 8.00001H8.37323C8.65323 8.00001 8.76656 8.20001 8.62656 8.44001L7.9999 9.53334",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.e483f767e02fc382fb89209b71579ee6.svg";
export { ForwardRef as ReactComponent };